import React from 'react';
import { Building2, Users, Mail } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';

const hubBase = '#/app/settings/users';

type SettingsUsersHubProps = {
  showOrgAdminSections: boolean;
};

export function SettingsUsersHub({ showOrgAdminSections }: SettingsUsersHubProps) {
  const links = [
    {
      href: `${hubBase}/account-details`,
      title: 'Account Details',
      description: 'Organisation name and account-level information.',
      icon: <Building2 className="h-8 w-8 text-action-blue" />
    },
    ...(showOrgAdminSections
      ? [
          {
            href: `${hubBase}/members`,
            title: 'Users',
            description: 'Teachers and staff in your organisation.',
            icon: <Users className="h-8 w-8 text-action-blue" />
          },
          {
            href: `${hubBase}/invitations`,
            title: 'Invitations',
            description: 'Pending and sent invitations.',
            icon: <Mail className="h-8 w-8 text-action-blue" />
          }
        ]
      : [])
  ];

  return (
    <div>
      <p className="text-gray-600 mb-6 max-w-2xl">
        Manage your organisation&apos;s account, team members, and invitations.
      </p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {links.map((item) => (
          <a key={item.href} href={item.href} className="block no-underline">
            <Card className="h-full transition-all hover:shadow-md hover:border-action-blue/40 cursor-pointer border-2 border-transparent">
              <CardHeader>
                <div className="flex items-start gap-3">
                  <div className="rounded-lg bg-action-blue/10 p-2">{item.icon}</div>
                  <div>
                    <CardTitle className="text-lg">{item.title}</CardTitle>
                    <CardDescription className="mt-1">{item.description}</CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <span className="text-sm text-action-blue font-medium">Open</span>
              </CardContent>
            </Card>
          </a>
        ))}
      </div>
    </div>
  );
}
